// extracted by mini-css-extract-plugin
module.exports = {"ads":"Ads_ads__1ytNK"};